import type * as Types from '../../../schemas/shopify/admin.types';

export type PickPageProductNodeFragment = Pick<
  Types.Product,
  'id' | 'handle' | 'title' | 'status' | 'publishedAt' | 'templateSuffix'
> & { featuredImage?: Types.Maybe<Pick<Types.Image, 'url'>> };

export const PickPageProductNodeFragmentDoc = `
    fragment PickPageProductNode on Product {
  id
  handle
  title
  status
  publishedAt
  templateSuffix
  featuredImage {
    url
  }
}
    `;
